<template>
  <div class="admin-conversation-sidebar rounded bg-white-custom">
    <div class="px-3 py-3">
      <div class="row">
        <div class="col-6 mt-1">
          <h6>Operator</h6>
        </div>
        <div class="col-6 mt-1">
          <span>
            {{ operatorInformation ? `${operatorInformation.fname} ${operatorInformation.lname}` : "" }}
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-6 mt-1">
          <h6>Opened</h6>
        </div>
        <div class="col-6 mt-1">
          <span>{{ formatTimestamp(conversationDetail.created_at, "M/D/YY h:mm a") }}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-6 mt-1">
          <h6>Closed</h6>
        </div>
        <div class="col-6 mt-1">
          <span>
            {{ conversationDetail.status != 'active' ? formatTimestamp(conversationDetail.closed_at, "M/D/YY h:mm a") : '' }}
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-6 mt-1">
          <h6>Language</h6>
        </div>
        <div
          v-if="conversationDetail.recipients && conversationDetail.recipients.length > 0"
          class="col-6 mt-1"
        >
          <span>{{ dialectLabel(conversationDetail.recipients[0].language) }}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-6 mt-1">
          <h6>Messages</h6>
        </div>
        <div class="col-6 mt-1">
          <span>{{ conversationDetail.message_count }}</span>
        </div>
      </div>
    </div>
    <div
      v-if="conversationDetail.artifact_id"
      class="d-flex align-items-center justify-content-around bg-extra-light border-top py-2"
    >
      <button
        class="btn btn-info btn-rounded"
        @click="exportModal(conversationDetail.artifact_id)"
        title="Export Conversation Artifact"
      >
        Export <b-icon-download class="ml-2 pt-1 overflow-visible" />
      </button>
      <button
        class="btn btn-info btn-rounded"
        @click="shareModal(conversationDetail.artifact_id)"
        title="Share externally through a magic link"
      >
        Share <b-icon-share class="ml-2 pt-1 overflow-visible" />
      </button>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import ShareExportModal from "@/components/admin/ShareExportModal";
import { EventBus } from "@/events/eventBus";
import moment from "moment-timezone";
import errorHandler from "@/mixins/errorHandler";

export default {
  name: "AdminConversationInfo",
  mixins: [errorHandler],
  props: {
    conversationDetail: Object,
  },
  data() {
    return {
      operatorInformation: null,
      fetchAbortController: null,
    };
  },
  computed: {
    ...mapGetters("agency", ["textDialects"]),
  },
  methods: {
    async loadOperatorInformation(operatorId) {
      try {
        this.fetchAbortController = new AbortController();
        const resp = await this.$ConveyApi.usersApi.getUser({
          userId: operatorId,
          signal: this.fetchAbortController.signal,
        });
        this.operatorInformation = resp.data.data;
      } catch(err) {
        if (!this.isApiCanceled(err)) {
          console.log("[AdminConversationInfo:loadOperatorInformation] ERROR: ", err);
        }
      }
    },
    formatTimestamp(t, format = "LT") {
      try {
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const formattedTime = moment.utc(t, "x").tz(tz).format(format);
        return formattedTime;
      } catch (e) {
        return t;
      }
    },
    dialectLabel(code) {
      let languageLabel = code;
      try {
        languageLabel = this.textDialects.find(o => o.code === code).label;
      } catch (error) {
        return code;
      }
      return languageLabel;
    },
    shareModal(id) {
      const $ = window.$;
      $("#id-modal-container").modal({
        backdrop: "static"
      });
      EventBus.$emit("open", {
        component: ShareExportModal,
        title: "Share Conversation Artifact",
        actionButton: "Share",
        closeOnClick: false,
        props: {
          artifactId: id,
          action: "share"
        }
      });
    },
    exportModal(id) {
      const $ = window.$;
      $("#id-modal-container").modal({
        backdrop: "static"
      });
      EventBus.$emit("open", {
        component: ShareExportModal,
        title: "Export Conversation Artifact",
        actionButton: "Download",
        closeOnClick: false,
        props: {
          artifactId: id,
          action: "export"
        }
      });
    },
  },
  watch: {
    conversationDetail: {
      async handler(conversation) {
        if (conversation && conversation.operator_id) {
          await this.loadOperatorInformation(conversation.operator_id);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  beforeDestroy() {
    if (this.fetchAbortController) {
      this.fetchAbortController.abort();
      this.fetchAbortController = null;
    }
  }
};
</script>
